import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../api/axios';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setDone(true);
    } catch {
      // Backend always returns 204 — error here would be a network/5xx issue.
      toast.error('Service temporairement indisponible.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-slate-200 p-8">
        <h1 className="text-2xl font-bold mb-2">Mot de passe oublié</h1>
        {done ? (
          <p className="mt-4 text-sm text-slate-600">
            Si un compte existe avec cet email, un lien de réinitialisation vient d'être envoyé.
            Il expire dans 60&nbsp;minutes.
          </p>
        ) : (
          <>
            <p className="text-sm text-slate-500 mb-6">
              Entrez votre email ; nous vous enverrons un lien pour choisir un nouveau mot de passe.
            </p>
            <form onSubmit={submit} className="space-y-4">
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                     placeholder="votre@email.tn"
                     className="w-full rounded-lg border border-slate-200 px-3 py-2 focus:outline-none focus:border-blue-500" />
              <button type="submit" disabled={busy}
                      className="w-full rounded-lg bg-blue-600 text-white font-semibold py-2.5 hover:bg-blue-700 disabled:opacity-50">
                {busy ? 'Envoi…' : 'Envoyer le lien'}
              </button>
            </form>
          </>
        )}
        <p className="text-sm text-slate-500 mt-6 text-center">
          <Link to="/login" className="text-blue-600 font-semibold">Retour à la connexion</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
